export default {
  title: "Proveedores",
  description: "Gestiona tus proveedores de boda",
  subtitle: "Añade y gestiona tus proveedores",
  addVendor: "Añadir Proveedor",
  editVendor: "Editar Proveedor",
  deleteVendor: "Eliminar Proveedor",
  noVendors: "No se encontraron proveedores",
  addFirstVendor: "Añade tu primer proveedor",
  hired: "Contratado",
  engagedVendors: "Proveedores Contratados",
  noEngagedVendors: "Aún no hay proveedores contratados",
  allVendors: "Todos los Proveedores",
  more: "más",
  vendorDeleted: "Proveedor eliminado exitosamente",
  vendorCreated: "Proveedor creado exitosamente",
  vendorUpdated: "Proveedor actualizado exitosamente",
  totalVendors: "{{count}} proveedores",
  
  categories: {
    venue: "Lugar",
    religious_venue: "Lugar Religioso",
    city_hall: "Ayuntamiento",
    catering: "Catering",
    photography: "Fotografía",
    videography: "Videografía",
    music: "Música",
    florist: "Florista",
    cake: "Pastel",
    dress: "Vestido",
    suit: "Traje",
    hair_makeup: "Peluquería y Maquillaje",
    decoration: "Decoración",
    transportation: "Transporte",
    flowers: "Flores",
    transport: "Transporte",
    beauty: "Belleza",
    other: "Otro",
    select: "Selecciona una categoría",
    none: "Ninguno",
    photos: "Fotos",
    preparation: "Preparación",
    reminder: "Recordatorio",
    task: "Tarea",
    vendor: "Proveedor",
    vendors: "Proveedores",
    custom: "Personalizado",
    photographer: "Fotógrafo",
    caterer: "Catering",
    attire: "Vestuario"
  },

  form: {
    name: "Nombre",
    category: "Categoría",
    contact: "Contacto",
    email: "Email",
    phone: "Teléfono",
    address: "Dirección",
    website: "Sitio Web",
    price: "Precio",
    notes: "Notas",
    rating: "Calificación",
    status: "Estado",
    statusHelper: "El estado determina la gestión del presupuesto y las tareas.",
    contactName: "Nombre de Contacto",
    deposit: "Depósito",
    depositPaid: "Depósito Pagado",
    contractSigned: "Contrato Firmado",
    country: "País",
    errors: {
      nameRequired: "El nombre es obligatorio",
      categoryRequired: "La categoría es obligatoria",
      statusRequired: "El estado es obligatorio",
      pricePositive: "El precio debe ser positivo",
      depositPositive: "El depósito debe ser positivo",
      capacityPositive: "La capacidad debe ser un número positivo"
    },
    new: "Nuevo Proveedor",
    edit: "Editar Proveedor",
    title: "Detalles del Proveedor",
    namePlaceholder: "Nombre del Proveedor",
    company: "Empresa",
    categoryPlaceholder: "Selecciona una categoría",
    emailPlaceholder: "Dirección de Email",
    phonePlaceholder: "Número de Teléfono",
    websitePlaceholder: "URL del Sitio Web",
    addressPlaceholder: "Dirección del Proveedor",
    notesPlaceholder: "Notas Adicionales",
    submit: "Guardar",
    cancel: "Cancelar",
    confirmCancel: "Cancelar",
    contactInfo: "Información de Contacto",
    capacity: "Capacidad Máxima",
    capacityPlaceholder: "Número máximo de personas",
    contactNamePlaceholder: "Nombre de Contacto",
    description: "Descripción",
    dueDate: "Fecha de Vencimiento",
    priority: "Prioridad"
  },

  status: {
    contacted: "Contactado",
    quote: "Presupuesto Recibido",
    booked: "Reservado",
    hired: "Contratado",
    deposit_paid: "Depósito Pagado",
    paid: "Pagado",
    cancelled: "Cancelado",
    to_contact: "Por Contactar",
    meeting_scheduled: "Reunión Programada",
    meetingScheduled: "Reunión Programada",
    quote_received: "Presupuesto Recibido",
    quoteReceived: "Presupuesto Recibido",
    depositPaid: "Depósito Pagado",
    completed: "Completado",
    researching: "Investigando",
    confirmed: "Confirmado",
    pending: "Pendiente",
    declined: "Rechazado"
  },

  actions: {
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    contact: "Contactar",
    book: "Reservar",
    add: "Añadir",
    addLong: "Añadir nuevo proveedor",
    importGuests: "Importar invitados"
  },

  messages: {
    vendorAdded: "Proveedor añadido exitosamente",
    vendorUpdated: "Proveedor actualizado exitosamente",
    vendorDeleted: "Proveedor eliminado exitosamente",
    error: "Ocurrió un error",
    createSuccess: "Proveedor añadido exitosamente",
    updateSuccess: "Proveedor actualizado exitosamente",
    deleteSuccess: "Proveedor eliminado exitosamente",
    deleteConfirm: "¿Estás seguro de que quieres eliminar este proveedor?"
  },

  confirm: {
    delete: "¿Estás seguro de que quieres eliminar este proveedor?",
    budgetRemoval: {
      title: "Eliminación de Presupuesto",
      message: "¿Estás seguro de que quieres eliminar el presupuesto asociado con este proveedor?",
      confirm: "Sí, eliminar",
      cancel: "Cancelar"
    }
  },

  confirmations: {
    delete: "¿Estás seguro de que quieres eliminar este proveedor?"
  },

  logs: {
    addingVendor: "Añadiendo proveedor...",
    updatingVendor: "Actualizando proveedor..."
  },

  errors: {
    submit: "Error al guardar el proveedor",
    addVendor: "Error al añadir el proveedor",
    updateVendor: "Error al actualizar el proveedor",
    deleteVendor: "Error al eliminar el proveedor",
    loadVendors: "Error al cargar proveedores",
    userOrWeddingNotFound: "Usuario o evento no encontrado"
  },

  search: {
    title: "Buscar Proveedores",
    searchPlaceholder: "Buscar proveedores",
    locationPlaceholder: "Ciudad o código postal",
    categoryPlaceholder: "Selecciona una categoría",
    sort: "Ordenar por",
    sortOptions: {
      relevance: "Relevancia",
      rating: "Puntuación",
      reviews: "Opiniones",
      distance: "Distancia",
      name: "Nombre"
    },
    findVendors: "Encontrar Proveedores",
    googleShort: "Buscar",
    googlePlaceholder: "Buscar un proveedor",
    googleResults: "Resultados de Búsqueda",
    googleNoResults: "No se encontraron resultados",
    googleError: "Ocurrió un error durante la búsqueda",
    googleErrorShort: "Error de búsqueda",
    locationRequired: "Por favor, introduzca una ubicación para la búsqueda",
    countries: {
      FR: "🇫🇷 Francia",
      BE: "🇧🇪 Bélgica",
      CH: "🇨🇭 Suiza",
      ES: "🇪🇸 España",
      IT: "🇮🇹 Italia",
      DE: "🇩🇪 Alemania",
      GB: "🇬🇧 Reino Unido",
      IE: "🇮🇪 Irlanda",
      CA: "🇨🇦 Canadá",
      US: "🇺🇸 Estados Unidos",
      AU: "🇦🇺 Australia",
      OTHER: "🌍 Otro"
    },
    filters: {
      title: "Filtros",
      category: "Categoría",
      status: "Estado",
      search: "Buscar",
      country: "País",
      location: "¿Dónde?",
      radius: "Radio"
    },
    google: "Búsqueda en Google",
    googleLong: "Buscar en Google (lugares, empresas, etc.)",
    placeholder: "Ciudad o código postal...",
    noResults: "No se encontraron resultados",
    noResultsDescription: "Intenta modificar tus criterios de búsqueda o ampliar tu área geográfica.",
    reset: "Restablecer búsqueda",
    searching: "Buscando",
    searchingDescription: "Estamos buscando los mejores proveedores...",
    addVendor: "Añadir este proveedor",
    add: "Añadir",
    site: "Sitio web",
    phone: "Teléfono",
    resultsCountSingular: "proveedor encontrado",
    resultsCountPlural: "proveedores encontrados",
    reviews: "opiniones",
    recommended: "Recomendado",
    new: "Nuevo"
  },
  
  empty: {
    title: "Sin proveedores",
    description: "Comienza a añadir tus proveedores de boda"
  },

  filters: {
    title: "Filtros",
    category: "Categoría",
    status: "Estado",
    all: "Todos",
    group: "Grupo",
    search: "Buscar proveedor",
    events: "Eventos",
    clear: "Limpiar filtros",
    apply: "Aplicar",
    previous: "Anterior",
    next: "Siguiente",
    reset: "Reiniciar",
    allCategories: "Todas las categorías"
  },

  groups: {
    family: "Familia",
    friends: "Amigos",
    colleagues: "Colegas",
    other: "Otro"
  },

  events: {
    ceremony: "Ceremonia",
    reception: "Recepción",
    both: "Ambos"
  },

  sort: {
    title: "Ordenar por",
    options: {
      name: "Nombre",
      category: "Categoría",
      status: "Estado",
      price: "Precio",
      notes: "Notas"
    }
  },

  modal: {
    title: "Detalles del Proveedor",
    readOnly: "Solo lectura",
    edit: "Editar",
    share: "Compartir",
    personalInfo: "Información Personal",
    companyInfo: "Información de la Empresa",
    contactInfo: "Información de Contacto",
    notes: "Notas",
    budget: "Presupuesto",
    documents: "Documentos",
    timeline: "Cronograma",
    tasks: "Tareas",
    reviews: "Reseñas",
    messages: "Mensajes",
    payments: "Pagos",
    contracts: "Contratos"
  },

  details: {
    contact: "Contacto",
    pricing: "Precios",
    documents: "Documentos",
    appointments: "Citas",
    payments: "Pagos"
  },

  vendors: {
    filters: {
      status: "Estado",
      all: "Todos",
      group: "Grupo",
      events: "Eventos"
    },
    status: {
      confirmed: "Confirmado",
      pending: "Pendiente",
      declined: "Rechazado"
    },
    groups: {
      family: "Familia",
      friends: "Amigos",
      colleagues: "Colegas",
      other: "Otro"
    },
    events: {
      ceremony: "Ceremonia",
      reception: "Recepción",
      both: "Ambos"
    },
    sort: {
      options: {
        name: "Nombre",
        category: "Categoría",
        status: "Estado",
        price: "Precio",
        notes: "Notas"
      }
    }
  },

  success: {
    budgetUpdated: "Presupuesto actualizado exitosamente",
    vendorAdded: "Proveedor añadido exitosamente",
    vendorAndBudgetUpdated: "Proveedor y presupuesto actualizados exitosamente",
    vendorUpdated: "Proveedor actualizado exitosamente"
  }
};
